import {createStrokeSVG} from './TEMPLATE'

// lucide: shapes
export const Shapes_Stroke2_Corner0_Rounded = createStrokeSVG({
  paths: [
    'M8.3 10a.7.7 0 0 1-.626-1.079L11.4 3a.7.7 0 0 1 1.198-.043L16.3 8.9a.7.7 0 0 1-.572 1.1Z',
    'M4 14h5a1 1 0 0 1 1 1v5a1 1 0 0 1 -1 1h-5a1 1 0 0 1 -1 -1v-5a1 1 0 0 1 1 -1z',
    'M14 17.5a3.5 3.5 0 1 0 7 0a3.5 3.5 0 1 0 -7 0Z',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})
